import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { getThreadMessageConnectionQuery } from '../../queries/thread/getThreadMessageConnection';
// import { getDMThreadMessageConnectionQuery } from '../../queries/directMessageThread/getDirectMessageThreadMessageConnection';

export const deleteMessageMutation = gql`
  mutation deleteMessage($id: ID!) {
    deleteMessage(id: $id)
  }
`;

const deleteMessageOptions = {
  props: ({ ownProps, mutate }) => ({
    ...ownProps,
    deleteMessage: id =>
      mutate({
        variables: {
          id,
        },
        update: store => {
          const data = store.readQuery({
            query: getThreadMessageConnectionQuery,
            variables: {
              id: ownProps.threadId || ownProps.thread.id,
            },
          });
          if (ownProps.isReplied) {
            data.thread.messageConnection.edges.map(edge => {
              edge.node.reply = edge.node.reply.filter(
                reply => reply.id !== id
              );
              return edge;
            });
            data.thread.messageCount--;
          } else {
            const deleteMessage = data.thread.messageConnection.edges.filter(
              ({ node }) => node.id === id
            );
            const replyCount =
              deleteMessage && deleteMessage[0].node.reply.length;
            data.thread.messageConnection.edges = data.thread.messageConnection.edges.filter(
              ({ node }) => node.id !== id
            );
            data.thread.messageCount =
              data.thread.messageCount - replyCount - 1;
          }

          // Write our data back to the cache.
          store.writeQuery({
            query: getThreadMessageConnectionQuery,
            data,
            variables: {
              id: ownProps.threadId,
            },
          });
        },
      }),
  }),
};

export default graphql(deleteMessageMutation, deleteMessageOptions);
